import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as Action from "../../../applicant/_redux/applicantActions";
import {
  Input,
  SelectInput,
} from "../../../../../_metronic/_partials/controls";
import { TextArea } from "../../../../../_metronic/_partials/controls/forms/TextArea";
import API from "../../../../helpers/devApi";
import * as Yup from "yup";
import { swalError, swalSuccess } from "../../../../helpers/swal";
import * as EmployeeListAction from "../../../employee/_redux/employeeActions";
import { Checkbox } from "antd";

const _init = {
  pre_international_address: "",
  pre_address_line_1: "",
  pre_divisions_id: "",
  pre_districts_id: "",
  pre_thana_id: "",
  pre_postal_code: "",
};

const PresentAddress = ({ id }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState(_init);
  const { division, pre_district, pre_thana, employeeProfile } = useSelector(
    ({ applicant, employeeList }) => ({
      division: applicant.division,
      pre_district: applicant.pre_district,
      pre_thana: applicant.pre_thana,
      employeeProfile: applicant.personal_info,
    }),
    shallowEqual
  );

  console.log({ employeeProfile });

  // Validation schema
  const validationSchema = Yup.object().shape({
    pre_address_line_1: Yup.string().required("Full address is required"),
    pre_divisions_id: Yup.string().nullable(),
    pre_districts_id: Yup.string().nullable(),
    pre_thana_id: Yup.string().nullable(),
  });

  const handleSaveProfile = async (values) => {
    values.pre_address_line_1 = values?.pre_address_line_1;
    values.pre_divisions_id =
      values?.pre_divisions_id === "" ? null : values?.pre_divisions_id;
    values.pre_districts_id =
      values?.pre_districts_id === "" ? null : values?.pre_districts_id;
    values.pre_thana_id =
      values?.pre_thana_id === "" ? null : values?.pre_thana_id;
    values.pre_international_address = values?.pre_international_address;
    if (employeeProfile?.is_same_as_permanent_address === 1) {
      values.per_address_line_1 = values?.pre_address_line_1;
      values.per_divisions_id = values?.pre_divisions_id;
      values.per_districts_id = values?.pre_districts_id;
      values.per_thana_id = values?.pre_thana_id;
      values.per_international_address = values?.pre_international_address;
    }

    if (id && values) {
      await API.patch(`/hrms_applicant/${id}`, values)
        .then(async (res) => {
          if (res.data.success) {
            dispatch(
              Action.createProfileScore(
                {
                  name: ["Present Address"],
                  applicant_id: id,
                },
                () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                }
              )
            );
            // await dispatch(Action.getApplicantPersonalInfo(id));
            swalSuccess("Present Address Updated Successfully!!");
            setLoading(false);
          } else {
            swalError("something went wrong");
          }
        })
        .catch((error) => {
          console.error(error);
        });
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(Action.getAllDivision());
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(Action.getApplicantPersonalInfo(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (employeeProfile && Object.keys(employeeProfile).length > 0) {
      if (employeeProfile.pre_divisions_id) {
        dispatch(
          Action.getAllPreDistrictByDivision(employeeProfile.pre_divisions_id)
        );
      }
      if (
        employeeProfile.pre_divisions_id &&
        employeeProfile.pre_districts_id
      ) {
        dispatch(
          Action.getAllPreThanaDistrictByDivision(
            employeeProfile.pre_divisions_id,
            employeeProfile.pre_districts_id
          )
        );
      }

      setProfile({
        pre_international_address:
          employeeProfile.pre_international_address ?? "",
        pre_address_line_1: employeeProfile.pre_address_line_1 ?? "",
        pre_address_line_2: employeeProfile.pre_address_line_2 ?? "",
        pre_divisions_id: employeeProfile.pre_divisions_id ?? "",
        pre_districts_id: employeeProfile.pre_districts_id ?? "",
        pre_thana_id: employeeProfile.pre_thana_id ?? "",
        pre_postal_code: employeeProfile.pre_postal_code ?? "",
      });
    } else {
      setProfile(_init);
    }
  }, [employeeProfile]);

  return (
    <div className="card card_body_box mb-5">
      <Formik
        initialValues={profile}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSaveProfile(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="card_header_with_edit_btn">
                  <div className="title">
                    <h2>Present Address</h2>
                  </div>
                </div>

                <hr />
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-md-12 mb-4">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-4">
                        <Input
                          label={"Full Address"}
                          value={values.pre_address_line_1}
                          isRequired
                          onChange={(e) => {
                            setFieldValue("pre_address_line_1", e.target.value);
                          }}
                        />
                        <Checkbox
                          checked={values.pre_international_address === "true"}
                          onChange={(e) => {
                            setFieldValue(
                              "pre_international_address",
                              e.target.checked?.toString()
                            );
                          }}
                        >
                          International Address
                        </Checkbox>
                        {errors.pre_address_line_1 &&
                          touched.pre_address_line_1 && (
                            <div className="text-danger">
                              {errors.pre_address_line_1}
                            </div>
                          )}
                      </div>
                      <div className="col-md-6 mb-4">
                        <SelectInput
                          label={"Division"}
                          options={division}
                          value={values.pre_divisions_id}
                          onChange={(value) => {
                            setFieldValue("pre_divisions_id", value);
                            dispatch(Action.getAllPreDistrictByDivision(value));
                          }}
                        />
                        {errors.pre_divisions_id &&
                          touched.pre_divisions_id && (
                            <div className="text-danger">
                              {errors.pre_divisions_id}
                            </div>
                          )}
                      </div>
                      <div className="col-md-6 mb-4">
                        <SelectInput
                          label={"District"}
                          options={pre_district}
                          value={values.pre_districts_id}
                          onChange={(value) => {
                            setFieldValue("pre_districts_id", value);
                            dispatch(
                              Action.getAllPreThanaDistrictByDivision(
                                values.pre_divisions_id,
                                value
                              )
                            );
                            setFieldValue("pre_thana_id", "");
                          }}
                        />
                        {errors.pre_districts_id && (
                          <div className="text-danger">
                            {errors.pre_districts_id}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-4">
                        <SelectInput
                          label={"Thana/ Upazila"}
                          options={pre_thana}
                          value={values.pre_thana_id}
                          onChange={(value) => {
                            setFieldValue("pre_thana_id", value);
                          }}
                        />
                        {errors.pre_thana_id && touched.pre_thana_id && (
                          <div className="text-danger">
                            {errors.pre_thana_id}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-4">
                        <label>
                          Postal Code{" "}
                          <span className="text-muted">(optional)</span>
                        </label>
                        <input
                          placeholder="Enter Postal Code"
                          type="text"
                          name="pre_postal_code"
                          value={values.pre_postal_code}
                          className="form-control"
                          onChange={(e) => {
                            setFieldValue("pre_postal_code", e.target.value);
                          }}
                        />
                        {errors.pre_postal_code && touched.pre_postal_code && (
                          <div className="text-danger">
                            {errors.pre_postal_code}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit_btn_group d-flex modal-footer m-0 p-0">
              {/* <button className='btn btn-default mr-4' >Cancel</button> */}
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={loading}
              >
                Save
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default PresentAddress;
